var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSima(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4275 18.2183H14.2393V20.6792H18.4275V18.2183Z",
    fill: "#1D204F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.65011 29.0245C3.85077 30.171 5.44764 30.8095 7.10771 30.8073C7.89555 30.8073 8.64142 30.5365 8.64142 29.9951C8.64142 29.4536 8.0607 29.1829 6.69214 28.9365C4.41257 28.5223 0.928242 27.989 0.928242 24.5209C0.928242 22.1777 2.87752 20.043 6.67183 20.043C8.9311 20.043 10.9629 20.686 12.5387 21.9706L10.2997 24.9351C9.0976 24.0241 7.54224 23.5679 6.44307 23.5679C5.40752 23.5679 5.17874 23.9402 5.17874 24.2935C5.17874 24.8349 5.73916 25.019 7.20925 25.2681C9.49016 25.662 12.8702 26.3253 12.8702 29.5172C12.8702 32.5657 10.6096 34.3282 6.89925 34.3282C3.95503 34.3282 1.94349 33.4565 0.470703 32.1298L2.65011 29.0245Z",
    fill: "#1D204F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2393 34.0833V21.7446H18.4275V34.0833H14.2393Z",
    fill: "#1D204F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.666 31.8184V34.083H22.9321L20.666 31.8184Z",
    fill: "#1D204F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9697 34.0834H36.1579V27.2271L31.9697 31.4153V34.0834Z",
    fill: "#1D204F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7588 34.0834L48.2173 32.3006H42.9083L42.3668 34.0834H37.832L42.9326 20.2544H48.1983L53.299 34.0834H48.7588ZM45.5655 23.9445L43.9899 28.8177H47.1412L45.5655 23.9445Z",
    fill: "#1D204F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1574 18.2237V24.0688L31.9691 28.2584L26.1444 34.0832L23.2163 31.1552L23.2177 31.1538L20.666 28.6022V22.7503L20.6674 22.7476L26.1456 28.2259L36.152 18.2183L36.1574 18.2237Z",
    fill: "#00B04E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSima);
export default __webpack_public_path__ + "static/media/sima.4350e90afedf461d4e4b33e4fecf8f9d.svg";
export { ForwardRef as ReactComponent };